__turbopack_context__.v({
  "copy": "PortalContactDetails-module__8t7nSW__copy",
  "details": "PortalContactDetails-module__8t7nSW__details",
  "icon": "PortalContactDetails-module__8t7nSW__icon",
  "item": "PortalContactDetails-module__8t7nSW__item",
  "label": "PortalContactDetails-module__8t7nSW__label",
  "value": "PortalContactDetails-module__8t7nSW__value",
});
